export default __webpack_public_path__ + "static/media/speed-search.8ccd204a.png";